import {decode} from 'he';
import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ItemBaseDto} from '../../common/shared/api/gateway/ItemBaseDto.interface';
import type {ApiResultVo} from '../../common/shared/api/karina/vo/ApiResultVo.interface';
import type {LandingPageVo} from '../../common/shared/api/karina/vo/page/LandingPageVo.interface';
import type {Maybe} from '../../graphql/generated/types';
import {LandingType} from '../../graphql/generated/types';

/**
 * 랜딩 타입별 API 경로 매핑
 *
 * Origin: PageKarinaApi.LANDING_TYPE_API_PATH_MAP
 */
const LANDING_TYPE_API_PATH_MAP: {[key in LandingType]: () => string} = {
  [LandingType.SeriesPoster]: () => '/v1/landing/series/poster',
  [LandingType.SeriesCard]: () => '/v1/landing/series/card',
  [LandingType.SingleList]: () => '/v1/landing/single/list',
  [LandingType.SeriesList]: () => '/v1/landing/series/list',
  [LandingType.SetList]: () => '/v1/landing/set/list',
  [LandingType.SetPoster]: () => '/v1/landing/set/poster',
};

/**
 * 랜딩 리스트 조회 (공통)
 *
 * Origin: pageKarinaApi.getLandingList
 * API: GET /api/gateway/view/v{version}/landing/{path} (동적)
 *
 * ⚠️ PageKarinaApi.getPath()가 'view' prefix를 자동으로 추가하므로
 *    Fetcher에서는 '/api/gateway/view/...' 형태로 호출해야 함
 */
export async function getLandingList(
  {
    landingType,
    dataKey,
    page: _page,
    size: _size,
    themeKeywordUid: _themeKeywordUid,
  }: {
    landingType: LandingType;
    dataKey: string;
    page?: Maybe<number>;
    size?: Maybe<number>;
    themeKeywordUid?: Maybe<string>;
  },
  options?: FetcherOptions
): Promise<ApiResultVo<LandingPageVo<ItemBaseDto>>> {
  // 원본 로직: 기본값 처리
  const page = _page || 0;
  const size = _size || 25;
  const themeKeywordUid = _themeKeywordUid || '';

  // 원본 로직: landingType에 따라 API path 결정
  const apiPath = LANDING_TYPE_API_PATH_MAP[landingType]();

  if (!apiPath) {
    throw new Error('카리나 API에 해당 랜딩 타입이 존재하지 않습니다.');
  }

  // ⚠️ PageKarinaApi는 this.getPath(apiPath)로 'view' prefix를 추가
  // → this.getPath('/v1/landing/series/card') → 'view/v1/landing/series/card'
  // → 따라서 fetcher에서는 '/api/gateway/view/v1/landing/series/card'로 호출
  const response = await axiosBffFetch(
    `/api/gateway/view${apiPath}`,
    {
      method: 'GET',
      params: {
        page,
        size,
        theme_keyword_uid: themeKeywordUid,
        reference: decode(dataKey),
      },
    },
    options
  );

  return response.data;
}
